// extracted by mini-css-extract-plugin
export default {"descriptionNavigationWrapper":"styles_descriptionNavigationWrapper__Wa3N1","titleWrapper":"styles_titleWrapper__QzDwE","contentWrapper":"styles_contentWrapper__u1826"};